import { useContext } from "react";

import AppContext from "../../../../AppContext";
import useReleaseOpsReservation from "../Hooks/UseReleaseOpsReservation";

const AppContextUseReleaseReservation = () => {
  const { leadIdCState, customerCState } = useContext(AppContext);
  return useReleaseOpsReservation({ customerId: customerCState.id, leadId: leadIdCState });
};

export default AppContextUseReleaseReservation;
